import type { MetricRequest, MetricResponse } from '@contracts';
import { resolvePeriod } from '@/lib/period';
import { authedFetch } from '@/lib/apiClient';
import { BRIDGE_URL as BRIDGE } from '@/lib/config';

/**
 * Única puerta de datos del front: pide UNA métrica a BridgeHub
 * (`/metrics/{metric}`) y recibe el contrato canónico `{ meta, data }`.
 * El front NO conoce Odoo ni Metabase — solo BridgeHub.
 */
export async function fetchMetric(req: MetricRequest): Promise<MetricResponse> {
  const { from, to } = resolvePeriod(req.period);
  const params = new URLSearchParams({ periodFrom: from, periodTo: to, view: req.view });
  if (req.companies?.length) params.set('companies', req.companies.join(','));
  if (req.scope?.branches?.length) params.set('branches', req.scope.branches.join(','));
  if (req.scope?.teams?.length) params.set('teams', req.scope.teams.join(','));
  if (req.scope?.groups?.length) params.set('groups', req.scope.groups.join(','));
  if (req.scope?.employees?.length) params.set('employees', req.scope.employees.join(','));
  if (req.scope?.regions?.length) params.set('regions', req.scope.regions.join(','));
  if (req.page) params.set('page', String(req.page));
  if (req.perPage) params.set('perPage', String(req.perPage));
  if (req.unscopedBranches) params.set('unscopedBranches', 'true');

  const res = await authedFetch(`${BRIDGE}/metrics/${req.metric}?${params.toString()}`);
  const body = await res.json();
  if (!body?.success) throw new Error(body?.message || 'Error al obtener la métrica');
  return body.data as MetricResponse;
}
